import { __decorate } from "tslib";
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import ButtonLoaderMixin from '@/helpers/vue_mixins/ButtonLoaderMixin';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import FormValidationsMixin, { validMobileNumber, } from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import { Component, Mixins } from 'vue-property-decorator';
import { required, email } from 'vuelidate/lib/validators';
import mutation from '@/plugins/graphql/mutations/v2/user-settings-update.gql';
import { MOBILE_MASK } from '@/helpers/constants/app';
import query from '@/plugins/graphql/queries/me.gql';
import AlertMixin from '@/helpers/vue_mixins/AlertMixin';
let AccountDetailForm = class AccountDetailForm extends Mixins(ButtonLoaderMixin, FormMixin, FormValidationsMixin, ViewportSizeMixin, AlertMixin) {
    constructor() {
        super(...arguments);
        this.me = null;
        this.form = {
            firstName: '',
            lastName: '',
            contactNumber: '',
            businessEmailAddress: '',
        };
    }
    onDialCodeChange({ dialCode }) {
        this.form.contactDialCode = `+${dialCode}`;
    }
    get formToParams() {
        const { contactNumber, ...form } = this.form;
        form.contactDialCode = '+63';
        if (contactNumber.includes('+63'))
            form.contactNumber = contactNumber.replaceAll(' ', '').substr(3, contactNumber.length);
        else
            form.contactNumber = contactNumber;
        return form;
    }
    get mobileMask() {
        return MOBILE_MASK;
    }
    async onSubmit() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.requestOnFlight();
            await this.update();
        }
    }
    async update() {
        return this.$apollo
            .mutate({
            mutation,
            variables: {
                input: {
                    userUuid: this.me?.uuid,
                    ...this.formToParams,
                },
            },
        })
            .then(() => {
            this.successNotification('Account Information Updated');
            this.$router.push({ name: 'user-profile' });
        });
    }
};
AccountDetailForm = __decorate([
    Component({
        components: {
            BaseTextField: () => import('@/components/v2/BaseTextField.vue'),
            ActionButton: () => import('@/components/action_button/Index.vue'),
            FormHeader: () => import('@/components/v2/FormHeader.vue'),
            PhoneInput: () => import('@/components/v2/PhoneInput.vue'),
        },
        validations: {
            form: {
                firstName: { required },
                lastName: { required },
                contactNumber: { required, validMobileNumber },
                businessEmailAddress: { required, email },
            },
        },
        apollo: {
            me: {
                query,
                update(data) {
                    const profile = data.me;
                    this.form = {
                        firstName: profile.firstName,
                        lastName: profile.lastName,
                        contactNumber: profile.contactNumber,
                        email: profile.email,
                        businessEmailAddress: profile.businessEmailAddress,
                    };
                    return profile;
                },
                skip() {
                    return !this.$store.state.session.token;
                },
            },
        },
    })
], AccountDetailForm);
export default AccountDetailForm;
